const states = {
    isDialogOpen: false,
    // 가이아 데이터
    siDoList: {
        constantGroups: [],
    },
    siGunGuList: {
        constantGroups: [],
    },
    eupMyeonDongList: {
        constantGroups: [],
    },
    // 상점별 zoo 데이터
    storeDeliveryPossibleAreaList: [],
    // 선택 값
    selectedSiDo: {
        constantGroupId: '',
        name: '',
    },
    selectedSiGunGu: {
        constantGroupId: '',
        name: '',
    },
    register: [],
    unregister: [],
};
export default states;
